import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from '../material/material.module';
import { MatTableComponent } from './mat-table/mat-table.component';
import { CrudComponent } from './crud/crud.component';
import { AvatarComponent } from './avatar/avatar.component';
import { DirectivesModule } from '../directives/directives.module';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ToasterService } from '../services/toaster/toaster.service';
import { InformativeNotificationComponent } from './informative-notification/informative-notification.component';
import { PagingSearchComponent } from './paging-search/paging-search.component';
import { FormsModule } from '@angular/forms';
import { PagingPaginatorComponent } from './paging-paginator/paging-paginator.component';
import { StatusLabelComponent } from './status-label/status-label.component';
@NgModule({
  declarations: [
    HeaderComponent,
    MatTableComponent,
    CrudComponent,
    AvatarComponent,
    ConfirmModalComponent,
    UploadImageComponent,
    InformativeNotificationComponent,
    PagingSearchComponent,
    PagingPaginatorComponent,
    StatusLabelComponent],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MaterialModule,
    DirectivesModule,
    MatSnackBarModule,
    FormsModule],
  exports: [
    HeaderComponent,
    MatTableComponent,
    CrudComponent,
    AvatarComponent,
    UploadImageComponent,
    MatSnackBarModule,
    InformativeNotificationComponent,
    PagingSearchComponent,
    PagingPaginatorComponent,
    StatusLabelComponent],
})
export class SharedModule {
  constructor(private toasterService: ToasterService) {
    this.toasterService.setNotificationComponent(InformativeNotificationComponent);
  }
}
